import React from 'react';
import { EXTERNAL_URLS } from 'legacyfrontend/constants';

const PAIS_ID_ARGENTINA = 1;

const DATA_RIGHTS_TEXT =
  'Dirección General de Defensa y Protección al Consumidor - El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326. La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.';

const REVOCATION_TEXT =
  'En los contratos celebrados a distancia el Pasajero podrá ejercer su derecho de revocación dentro de los DIEZ (10) días corridos contados a partir de realizada la compra. (Resolución 954/2025). Los pasajes aéreos se rigen por la política de cancelación y condiciones tarifarias de la cía. aérea, informadas antes de la contratación (decreto 809/2024).';

export const LEGAL_INFORMATION_TITLE = 'Información Legal';

export function showsArgentinaLegalDetails(paisId?: number): boolean {
  return paisId == null || paisId === PAIS_ID_ARGENTINA;
}

export const LegalInformationBody: React.FC<{ paisId?: number }> = ({ paisId }) => {
  const showArgentinaDetails = showsArgentinaLegalDetails(paisId);

  return (
    <div className='flex flex-col gap-4 footer-modal-rich-text'>
      <p>{DATA_RIGHTS_TEXT}</p>
      {showArgentinaDetails ? (
        <p>
          <strong>Ley 24.240. </strong>
          Autoridad Nacional de aplicación. Defensa de las y los Consumidores. Para reclamos ingrese{' '}
          <a href={EXTERNAL_URLS.ARGENTINA_CONSUMER_DEFENSE} rel='noreferrer' target='_blank'>
            aquí
          </a>
          .
        </p>
      ) : null}
      <p>{REVOCATION_TEXT}</p>
    </div>
  );
};
